<template>
  <div class="card">
    <div class="card__title">
      <h5>Logs</h5>
    </div>
    <div class="card__content">
      <div class="table-responsive">
        <table>
          <thead>
            <tr>
              <th># Doc.</th>
              <th>Detalles</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(log, index) in logs" :key="index" v-show="log.respuestas.length > 0">
              <td>{{ log.numero_documento }} ({{ log.tipo_comprobante.descripcion }})</td>
              <td>
                <table>
                  <thead>
                    <tr>
                      <th>T. Ambiente</th>
                      <th>Fecha</th>
                      <th>Respuesta</th>
                      <th>Tipo</th>
                      <th>Información Adic.</th>
                      <th>Identificador</th>
                      <th>Estado</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="respuesta in log.respuestas" :key="respuesta.id_comprobante">
                      <td>{{ respuesta.tipo_ambiente.descripcion }}</td>
                      <td>{{ respuesta.fecha }}</td>
                      <td>{{ respuesta.respuesta }}</td>
                      <td>{{ respuesta.tipo }}</td>
                      <td>{{ respuesta.informacion_adicional }}</td>
                      <td>{{ respuesta.identificador }}</td>
                      <td>{{ respuesta.estado }}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td>
                <a
                  target="_blank"
                  :href="url + '/comprobantes/' + log.id_comprobante + '/ride'"
                  class="btn-secondary btn--text"
                >
                  <i class="fa fa-eye"></i>
                </a>
                <a
                  v-if="log.id_estado_comprobante === 'AUT'"
                  target="_blank"
                  :href="url + '/comprobantes/' + log.id_comprobante + '/xml'"
                  class="btn-success btn--text"
                >
                  <i class="fa fa-file-excel-o"></i>
                </a>
              </td>
            </tr>
            <tr v-if="logs.length === 0">
              <td colspan="3">
                <strong>No se ha encontrado logs.</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    logs: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    }
  },
  data: function() {
    return {
      url: url
    };
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/reportes/TablaLogsReporteVentas.vue